import { rosterTheme as t } from "./rosterTheme";

export default function RosterActivityTimeline({ stateLog, assignmentAudit, loading }) {
  const items = [
    ...(stateLog || []).map((s) => ({
      id: s.log_id,
      at: s.created_at,
      type: "lifecycle",
      title: `Roster ${s.from_status || "?"} → ${s.to_status}`,
      detail: s.notes,
    })),
    ...(assignmentAudit || []).map((a) => ({
      id: a.audit_id,
      at: a.created_at,
      type: "assignment",
      title: `Assignment ${a.action}`,
      detail: a.change_reason,
    })),
  ].sort((a, b) => new Date(b.at) - new Date(a.at));

  return (
    <div className={t.cardPad}>
      <h3 className={t.cardHeader + " mb-3"}>Activity timeline</h3>
      {loading ? (
        <div className="space-y-2 animate-pulse">
          {[1, 2, 3].map((i) => (
            <div key={i} className="h-12 bg-gray-100 rounded" />
          ))}
        </div>
      ) : items.length === 0 ? (
        <p className="text-sm text-gray-500">No activity recorded yet.</p>
      ) : (
        <ul className="space-y-3 max-h-64 overflow-y-auto">
          {items.map((item) => (
            <li key={item.id} className="flex gap-3 text-sm">
              <span
                className={`mt-1 h-2 w-2 rounded-full shrink-0 ${
                  item.type === "lifecycle" ? "bg-teal-500" : "bg-amber-500"
                }`}
              />
              <div>
                <p className="font-medium text-gray-900">{item.title}</p>
                {item.detail && <p className="text-gray-600 text-xs">{item.detail}</p>}
                <p className="text-xs text-gray-400 mt-0.5">
                  {item.at ? new Date(item.at).toLocaleString() : ""}
                </p>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
